import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { UserService } from '../../services/user.service';
import { ComplexUserModel } from './../../models/complex-user.model';
import { UserModel } from './../../models/user.model';
import {
  AddUser,
  EditUser,
  FilterUsers,
  ImportUsers,
  RemoveUser,
} from './../action/management.action';

export interface UserStateModel {
  users: UserModel[];
  usersTotal: number;
}

@State<UserStateModel>({
  name: 'userstate',
  defaults: {
    users: [],
    usersTotal: 0,
  },
})
@Injectable()
export class UserState {
  constructor(private userService: UserService, private store: Store) {}

  @Selector()
  static users(ctx: UserStateModel) {
    return ctx.users;
  }

  @Selector()
  static usersTotal(ctx: UserStateModel) {
    return ctx.usersTotal;
  }

  @Action(FilterUsers)
  async filterUsers(ctx: StateContext<UserStateModel>, action: FilterUsers) {
    var data = new ComplexUserModel();

    data = await this.userService.getAll().toPromise();

    if (data) {
      ctx.patchState({ users: data.data, usersTotal: data.total });
    }
  }

  @Action(AddUser)
  async addUser(ctx: StateContext<UserStateModel>, action: AddUser) {
    var data = await this.userService.add(action.model).toPromise();

    if (data) {
      this.store.dispatch(new FilterUsers());
    }
  }

  @Action(EditUser)
  async editUser(ctx: StateContext<UserStateModel>, action: EditUser) {
    var data = await this.userService.update(action.model).toPromise();

    if (data) {
      this.store.dispatch(new FilterUsers());
    }
  }

  @Action(RemoveUser)
  async removeUser(ctx: StateContext<UserStateModel>, action: RemoveUser) {
    var data = await this.userService.remove(action.modelId).toPromise();

    if (data) {
      this.store.dispatch(new FilterUsers());
    }
  }

  @Action(ImportUsers)
  async importUsers(ctx: StateContext<UserStateModel>, action: ImportUsers) {
    var data = await this.userService.import(action.data).toPromise();

    if (data) {
      this.store.dispatch(new FilterUsers());
    }
  }
}
